module.exports = __webpack_public_path__ + "img/103.d4be294a.png";